import type { MRDrawerItem } from '@/components/MRDrawer'
import type { user } from '@/features/users/types'

const ADMIN_PORTAL_URLS = {
  prod: 'https://admin.miranow.ai/',
  qa: 'https://qa-admin.miranow.ai/',
  dev: 'http://localhost:3000/',
} as const

type AdminPermissionUser =
  | (Pick<user, 'is_admin'> & Partial<Pick<user, 'is_billing_admin'>>)
  | null
  | undefined

export const getAdminPortalUrl = (environment?: string) => {
  if (environment === 'qa') return ADMIN_PORTAL_URLS.qa
  if (environment === 'dev') return ADMIN_PORTAL_URLS.dev
  return ADMIN_PORTAL_URLS.prod
}

export const getDrawerItemsForUser = (
  items: MRDrawerItem[],
  selfUser: AdminPermissionUser,
  isDelegationMode = false
) =>
  items.filter(
    item => {
      if (item.text === 'adminPortal') return selfUser?.is_admin === true
      if (item.text === 'settings' && isDelegationMode) {
        // MIRA-4332: Only the signed-in admin may see Settings during delegation.
        // Billing admin or delegation access alone does not grant visibility.
        return selfUser?.is_admin === true
      }
      return true
    }
  )

const AUDIT_LOG_GUIDE_SECTION =
  'step-by-step-guide-to-enable-audit-log-in-purview-portal'

export const getAuditLogGuideUrl = (environment?: string) =>
  `${getAdminPortalUrl(environment)}settings?tab=Source&scrollTo=${AUDIT_LOG_GUIDE_SECTION}`

export const ADMIN_PORTAL_URL = getAdminPortalUrl(process.env.REACT_APP_ENV)

export const AUDIT_LOG_GUIDE_URL = getAuditLogGuideUrl(
  process.env.REACT_APP_ENV
)
